import SysDialog from "./SysDialog.vue"
import SysLoading from "./SysLoading"
import SysSwiper from "./SysSwiper"
import captcha from "./captcha.vue";
import SysContact from "./SysContact.vue";

const sysDialog = {
  install: Vue => {
    Vue.component("SysDialog", SysDialog);
  }
};

const sysLoading = {
  install: Vue => {
    Vue.component("SysLoading", SysLoading);
  }
};

const sysSwiper = {
  install: Vue => {
    Vue.component("vCaptcha", captcha);
    Vue.component("SysSwiper", SysSwiper);
  }
};

const sysContact = {
  install: Vue => {
    Vue.component("SysContact", SysContact);
  }
};

const sys3dswiper = {
  install: Vue => {
    Vue.component("sys3dswiper", Sys3dswiper);
  }
};

export {sysDialog, sysLoading, sysSwiper, sysContact, sys3dswiper}



// WEBPACK FOOTER //
// ./src/components/common/index.js